import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { InTimeRenderer } from 'timeSheet/components/CellRenderers';

const useInColumn = ({
  updateStartTime,
  updateEndTime,
  hasActionPermission,
  setIsPromptOpen,
  updateOSStartTime,
  updateOSEndTime,
  allowUpdateExternal = false
}) => {
  const { t, timeFormat } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return InTimeRenderer({
        rowData: params.data,
        columnData: {
          updateStartTime,
          updateEndTime,
          updateOSStartTime: allowUpdateExternal ? updateOSStartTime : undefined,
          updateOSEndTime: allowUpdateExternal ? updateOSEndTime : undefined,
          readOnly: !hasActionPermission,
          onOutsideClickSave: true,
          showClientTimesheetOriginalHours: true,
          allowUpdateExternal,
          setIsPromptOpen,
          timeFormat
        }
      });
    },
    [
      updateStartTime,
      updateEndTime,
      updateOSStartTime,
      updateOSEndTime,
      hasActionPermission,
      allowUpdateExternal,
      setIsPromptOpen,
      timeFormat
    ]
  );

  return useMemo(
    () => ({
      field: 'actualIn',
      headerName: t('in'),
      cellClass: 'justify-start',
      width: 125,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useInColumn;
